export enum BannerVariant {
  Default = 'default',
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Critical = 'critical',
}
